import styled from 'astroturf/react';

// These are all used for fading out the LoadingDots loading indicator
// and fading in the text for the result counts in multiple places
export const FADE_DURATION = 180;

export const CountText = styled.span`
  transition: ${FADE_DURATION}ms opacity;
`;

export type TransitionState =
  | 'entering'
  | 'entered'
  | 'exiting'
  | 'exited'
  | 'unmounted';

export const transitions = {
  entering: { opacity: '0' },
  entered: { opacity: '1' },
  exiting: { opacity: '0' },
  exited: { opacity: '0' },
  unmounted: { opacity: '0' },
};
